<template>
    <v-container class="pa-5" fluid>
        <v-row dense>
            <v-col cols="auto">
                <page-title>Generator Etykiet</page-title>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-container fluid class="pa-0">
                    <v-row>
                        <v-col cols="12" md="6">
                            <v-card
                                class="mx-auto fill-height"
                            >
                                <v-card-title>
                                    <v-icon
                                        left
                                        large
                                    >
                                        mdi-printer
                                    </v-icon>
                                    Etykiety standardowe
                                </v-card-title>
                                <v-card-text>
                                    <div class="text--primary">
                                        Wydruk etykiet standardowych
                                    </div>
                                </v-card-text>
                                <v-card-actions>
                                    <v-btn
                                        text
                                        color="info"
                                        @click="openView('shipmentsLabelsGeneratorStandard')"
                                    >
                                        Otwórz
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-card
                                class="mx-auto fill-height"
                            >
                                <v-card-title>
                                    <v-icon
                                        left
                                        large
                                    >
                                        mdi-printer
                                    </v-icon>
                                    Etykiety billboardowe
                                </v-card-title>
                                <v-card-text>
                                    <div class="text--primary">
                                        Wydruk etykiet dla billboardów
                                    </div>
                                </v-card-text>
                                <v-card-actions>
                                    <v-btn
                                        text
                                        color="info"
                                        @click="openView('shipmentsLabelsGeneratorBillboard')"
                                    >
                                        Otwórz
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="6">
                            <v-card
                                class="mx-auto fill-height"
                            >
                                <v-card-title>
                                    <v-icon
                                        left
                                        large
                                    >
                                        mdi-printer
                                    </v-icon>
                                    Etykiety rewizyjne
                                </v-card-title>
                                <v-card-text>
                                    <div class="text--primary">
                                        Wydruk etykiet rewizyjnych
                                    </div>
                                </v-card-text>
                                <v-card-actions>
                                    <v-btn
                                        text
                                        color="info"
                                        @click="openView('shipmentsLabelsGeneratorRevision')"
                                    >
                                        Otwórz
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-col>
                        <v-col v-if="ableToReadHistory" cols="12" md="6">
                            <v-card
                                class="mx-auto fill-height"
                            >
                                <v-card-title>
                                    <v-icon
                                        left
                                        large
                                    >
                                        mdi-history
                                    </v-icon>
                                    Historia
                                </v-card-title>
                                <v-card-text>
                                    <div class="text--primary">
                                        Zestawienie informacji o wydrukach etykiet
                                    </div>
                                </v-card-text>
                                <v-card-actions>
                                    <v-btn
                                        text
                                        color="info"
                                        @click="openView('shipmentsLabelsGeneratorPrintHistory')"
                                    >
                                        Otwórz
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-container>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import router from '@/router'
import PageTitle from '@/components/common/PageTitle'
import { errorHandler } from '@/utils/errorHandler'
import { hasUserPermission } from '@/utils/permissionsHandler'

export default {
    name: 'LabelsGenerator',
    components: {
        PageTitle,
    },
    computed: {
        ableToReadHistory() {
            return hasUserPermission('sendings_admin_read')
        },
    },
    methods: {
        openView(view) {
            router.push({name: view})
                .catch(error => {
                    // eslint-disable-next-line no-undef
                    errorHandler(error)
                })
        },
    }
}
</script>